import { useContext } from "react";
import { CsAttributeApiContext, } from "../context/CsAttributeApiContext";
/**
 * Provides a simplified API for attributes
 * - requires {@linkcode CsAttributeController}
 * @category Hook
 * @category CsAttribute
 * @category API
 * @returns {CsAttributeApi}
 */
export function useCsAttributeApi() {
    return useContext(CsAttributeApiContext);
}
//# sourceMappingURL=useCsAttributeApi.js.map